import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deletePublicProjectHistoryRequest: ['response'],
    deletePublicProjectHistorySuccess: ['response'],
    deletePublicProjectHistoryFailure: ['error'],
})

export const deletePublicProjectHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deletePublicProjectHistoryRequest = state =>
    state.merge({ success: null })

const deletePublicProjectHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deletePublicProjectHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_PUBLIC_PROJECT_HISTORY_REQUEST]: deletePublicProjectHistoryRequest,
    [Types.DELETE_PUBLIC_PROJECT_HISTORY_SUCCESS]: deletePublicProjectHistorySuccess,
    [Types.DELETE_PUBLIC_PROJECT_HISTORY_FAILURE]: deletePublicProjectHistoryFailure,
})
